import { call, put } from 'redux-saga/effects';
import { RTCClient } from 'utils/webrtc';
import { interactionTriggered } from 'features/application/actions';

export function* muteVideoSaga() {
  yield put(interactionTriggered('muteVideo'));
  yield call(RTCClient.publishingFeed.stopVideoBroadcasting);
}
